'use strict';

$('body').on('refreshRegex', function () {
  InitMask();
});

function InitMask() {
  var manualEdit = false;
  $('body').on('countryPhone:open', function () {
    manualEdit = true;
  });

  $('.shipping-form .select-phone-regex').on('change', function (e) {
    var phoneNumber = $('.shipping-phone-control').val();
    var diallingCode = $(this).children('option:selected').data('phone-indicative') || '';
    var validNumber = phoneNumber.replace(/\s/g, '');
    diallingCode = diallingCode.toString();

    var mask = $(this).children('option:selected').data('phone-mask') || '';
    $('.shipping-phone-control').unmask();
    
    if (!validNumber && diallingCode) {
      $('.shipping-phone-control').val(`+${diallingCode} `);
    } else if (validNumber && diallingCode) {

      if (validNumber.startsWith('+' + diallingCode) || validNumber.startsWith('00' + diallingCode)) {
        $('.shipping-phone-control').val(phoneNumber);
      }
      else if (validNumber.startsWith('+')) {
        $('.shipping-phone-control').val(`+${diallingCode} `);
      }
      else if (validNumber.startsWith('00')) {
        $('.shipping-phone-control').val(`00${diallingCode} `);
      }

    } else if (manualEdit) {
      $('.shipping-phone-control').val(diallingCode ? `+${diallingCode} ` : '');
    }
    
    if (mask) {
      $('.shipping-phone-control').mask(`+${diallingCode} ${mask.toString()}`);
    }
    
    if (mask && diallingCode) {

      var InfoMaskDiallingCode =`<span>+${diallingCode} ${mask.toString()}</span>`;
      $('.skp-error-message-phone .mask-diallingCode').empty().append(Resources.LABEL_FORM_PHONE + InfoMaskDiallingCode);

    } else {
      $('.skp-error-message-phone .mask-diallingCode').empty();
    }
  });
  
  $('.shipping-phone-control').on('keydown', function (event) {
    var keyCode = event.keyCode || event.which;
    var inputValue = $(this).val();
    var diallingCode = $('.select-phone-regex option:selected').data('phone-indicative') || '';
    var diallingCodeLength = diallingCode ? diallingCode.toString().length + 2 : 0;

    if (keyCode === 8 && inputValue.length <= diallingCodeLength) {
      event.preventDefault();
    }
  });

  $('.shipping-phone-control').on('paste', function (e) {
    e.preventDefault();
  });

  $('.shipping-phone-control').on('input mouseup keyup keydown', function (event) {
    var selectedNumber = window.getSelection().toString();
    var diallingCode = $('.select-phone-regex option:selected').data('phone-indicative') || '';
    if (selectedNumber !== '') {
      if (event.keyCode == 8 || event.keyCode == 46) {
        $(this).val(diallingCode ? `+${diallingCode.toString()} ` : "");
      }
    }
  });
}